import React, {Component} from 'react';
import classes from './scss/detailed.module.scss';

import Mail from './../../Assets/images/Important Mail_50px.png';
import Phone from './../../Assets/images/Phone_48px.png';




let description, quantity, unit, total, sum=0, spliced, j=0;

class Detailed1 extends Component {
    constructor(){
        super();

        this.state = {
            desciption_list: [],
            quantity_list: [],
            unit_list: [],
            total_list: [],
            ssum: 0
        }
        this.addToList = this.addToList.bind(this, true);
        this.remove = this.remove.bind(this, true);
        
    }

    // componentDidMount(){
      
    // }

    addToList(value){
        description = description.value;        
        unit = unit.value;
        quantity = quantity.value;

        total = (parseFloat(unit)) * parseFloat(quantity);
        if(isNaN(total)){
            total = 0;
        }
        sum += total;


        if(description === '' || unit === '' || quantity === ''){
            alert('Please fill the forms');
        }else{
            this.setState({
                desciption_list: [...this.state.desciption_list, description],
                quantity_list: [...this.state.quantity_list, quantity],
                unit_list: [...this.state.unit_list, unit],
                total_list: [...this.state.total_list, (total).toFixed(2)],
                ssum: (sum).toFixed(2)
            })
            ++j;
        }
    }

     remove(param, idx){
         console.log("called "+ idx);
         const description_ = [...this.state.desciption_list];
         const quantity_ = [...this.state.quantity_list];
         const unit_ = [...this.state.unit_list];
         const total_ = [...this.state.total_list];

         description_.splice(idx, 1);
         quantity_.splice(idx, 1);
         unit_.splice(idx, 1);
         spliced = total_.splice(idx, 1);
         sum-=spliced;

         this.setState({
             desciption_list: description_,
             quantity_list: quantity_,
             unit_list:  unit_,
             total_list:  total_,
             ssum: (sum).toFixed(2)
         });
         --j
     }
     
 bank_details(params){
    if(params === "invoice"){
        return(
            <div className={classes.bank_details}>
                <hr/>
                <h3>BANK DETAILS</h3>
                <hr/>
                <input name='acc_name' defaultValue="Account Name: CYST COMPANY LIMITED"/>
           
                <input name='bank' defaultValue="Bank: ECOBANK GHANA LIMITED"/>
                <input name='acc_number' defaultValue="Account Number: 1441001939689"/>
                <input name='time' defaultValue="Payment Due Two Days After Receipt of Invoice"/>
                                
            </div>
        );

    }else{
        return(
            <div className={classes.space}>

            </div>
        );
    }
}

show_form(params){
    if(params === true){
        return(
            <div>
                <form className={classes.quant}>
                <div className={classes.inputBox1}>
                    <div className={classes.description}>
                        <input name='description' ref={input =>description = input} placeholder='Description' />
                    </div>
                </div>
                <div className={classes.inputBox2}>
                    <div className={classes.quatity}>
                        <input name='quantity' type='number' ref={input =>quantity = input} placeholder='Quantity' />
                    </div>
                </div>
                <div className={classes.inputBox3}>
                    <div className={classes.unit}>
                        <input name='unit' type='number' ref={input =>unit = input} placeholder='Unit Price' />
                    </div>
                </div>
                {/* <div className={classes.inputBox}>
                    <div className={classes.total}>
                        <input name='total' type='number' ref={input =>total = input} placeholder='Total' />
                    </div>
                </div> */}
                </form>
                <button className={classes.button} onClick={this.addToList}>Add Entry</button>

            </div>
        );
    }
}

show_remove_title(params){
    if(params === true){
        return(<th >REMOVE</th>);
    }

}

    show_remove_btns(params, idx){
        if(params === true){
            return( <td className={classes.rem}> <button onClick={(e)=>this.remove(e, idx)}>X</button> </td>);
        }
    
}
more_tables(params){
    let table = []
    if(params === false){
        
       for(let i=0;i< (16-j);i++){
           table.push(
            <tr className = {classes.table} key={i}>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>
           )
       }

    }

    return table
}
   


    render(){
        return(
            <div className={classes.background}>
                <table>
                    <thead>
                        <tr>
                        <th className={classes.desc}>DESCRIPTION</th>
                        <th>QUANTITY</th>
                        <th>UNIT AMOUNT {'('+this.props.currency+')'}</th>
                        <th>TOTAL {'('+this.props.currency+')'}</th>
                        {this.show_remove_title(this.props.show)}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.desciption_list.map((item, idx) =>{
                            
                            return(
                             
                                <tr key={idx}>
                                    <td className={classes.des} >{item}</td>
                                    <td>{this.state.quantity_list[idx]}</td>
                                    <td>{this.state.unit_list[idx]}</td>
                                    <td>{this.state.total_list[idx]}</td>
                                    {this.show_remove_btns(this.props.show, idx)} 
                                </tr>                             
                               
                            )
                        })}
                       {this.more_tables(this.props.show)}
                       
                                
                    </tbody>
                </table>
                        
                {this.show_form(this.props.show)}

                {this.bank_details(this.props.type)}

                <div className={classes.grand}>
                <h2>
                    GRAND TOTAL: {this.props.currency} {this.state.ssum}
                </h2>
            </div>

            <div className={classes.contact}>
                <p>CONTACT DETAILS:</p>
                <p><span><img src={Mail} alt="&"/></span> business@teamcyst.com</p>
                <p><span><img src={Phone} alt="&"/></span> +233-555-957-484</p>
            </div>
            

            </div>
        );
    }
}

export default Detailed1;